import React, { useState, useEffect } from 'react';
import { MainLayout } from '../components/layout/MainLayout';
import { SubscriptionsList } from '../components/sections/SubscriptionsList';
import { subscriptionService } from '../services/subscriptionService';

export const SubscriptionsPage = () => {
    const [subscriptions, setSubscriptions] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchSubscriptions();
    }, []);

    const fetchSubscriptions = async () => {
        try {
            setIsLoading(true);
            const data = await subscriptionService.getAllSubscriptions();
            setSubscriptions(data);
            setError(null);
        } catch (err) {
            setError('Failed to fetch subscriptions. Please try again later.');
            console.error('Error fetching subscriptions:', err);
        } finally {
            setIsLoading(false);
        }
    };

    if (isLoading) {
        return (
            <MainLayout>
                <div className="space-y-6">
                    <h1 className="text-2xl font-bold text-gray-900">Your Subscriptions</h1>
                    <SubscriptionsList 
                        subscriptions={[]} 
                        onSubscriptionUpdate={fetchSubscriptions}
                        isLoading={true}
                    />
                </div>
            </MainLayout>
        );
    }

    if (error) {
        return (
            <MainLayout>
                <div className="text-center text-red-600 p-4">
                    {error}
                </div>
            </MainLayout>
        );
    }

    return (
        <MainLayout>
            <div className="space-y-6">
                <h1 className="text-2xl font-bold text-gray-900">Your Subscriptions</h1>
                <SubscriptionsList 
                    subscriptions={subscriptions} 
                    onSubscriptionUpdate={fetchSubscriptions}
                    isLoading={isLoading}
                />
            </div>
        </MainLayout>
    );
};